import React, { useState } from 'react';
import { AppBar, Toolbar, Button, Box, Typography, IconButton, Paper, Menu, MenuItem, ListItemIcon, ListItemText, Drawer, List, ListItemButton, Divider, Collapse } from '@mui/material';
import { WhatsApp, Phone, Email, BusinessCenter, School, RecordVoiceOver, Extension, CardGiftcard, ArrowDropDown, Menu as MenuIcon, Close, ExpandLess, ExpandMore } from '@mui/icons-material';
import logo from '../assets/images/logo.jpg';
import qrCode from '../assets/images/qrcode.jpg';

function Header() {
  const [showQR, setShowQR] = useState(false);
  const [coursesAnchorEl, setCoursesAnchorEl] = useState(null);
  const coursesMenuOpen = Boolean(coursesAnchorEl);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCoursesOpen, setMobileCoursesOpen] = useState(false);

  const handleCoursesMenuOpen = (event) => {
    setCoursesAnchorEl(event.currentTarget);
  };

  const handleCoursesMenuClose = () => {
    setCoursesAnchorEl(null);
  };

  const toggleMobileDrawer = (open) => () => {
    setMobileOpen(open);
  };

  const handleToggleMobileCourses = () => {
    setMobileCoursesOpen((prev) => !prev);
  };

  const courses = [
    { name: 'All Courses', href: '/courses', icon: <School /> },
    { name: 'Business Chinese', href: '/business-chinese', icon: <BusinessCenter /> },
    { name: 'Exam Preparation', href: '/exam-preparation', icon: <School /> },
    { name: 'Speech & Eloquence', href: '/speech-eloquence', icon: <RecordVoiceOver /> },
    { name: 'Immersion Programs', href: '/immersion-programs', icon: <Extension /> },
    { name: 'Tailored Programs', href: '/courses#tailored-programs', icon: <CardGiftcard /> }
  ];

  return (
    <Box sx={{ position: 'relative' }}>
      {/* 顶部联系信息栏 */}
      <Box
        sx={{
          backgroundColor: '#f8f9fa',
          borderBottom: '1px solid #e9ecef',
          py: 1
        }}
      >
        <Box sx={{ maxWidth: 1400, mx: 'auto', width: '100%', px: { xs: 2, md: 4 } }}>
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'flex-end', 
            alignItems: 'center',
            minHeight: 30
          }}>
            {/* 桌面端联系信息 */}
            <Box sx={{ 
              display: { xs: 'none', sm: 'flex' }, 
              alignItems: 'center', 
              gap: 4 
            }}>
              {/* 电话 */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Phone sx={{ fontSize: '1.1rem', color: '#07284b' }} />
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: '#374151',
                    fontWeight: 600,
                    fontSize: '0.85rem'
                  }}
                >
                  +65 89208197
                </Typography>
              </Box>

              {/* 邮箱 */}
              <Box 
                component="a"
                href="mailto:info@chihuimandarin.com"
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 0.5,
                  textDecoration: 'none',
                  cursor: 'pointer',
                  transition: 'opacity 0.2s ease',
                  '&:hover': {
                    opacity: 0.8
                  }
                }}
              >
                <Email sx={{ fontSize: '1.1rem', color: '#07284b' }} />
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: '#374151',
                    fontWeight: 600,
                    fontSize: '0.85rem'
                  }}
                >
                  info@chihuimandarin.com
                </Typography>
              </Box>

              {/* 桌面端 WhatsApp */}
              <Box
                sx={{ 
                  display: { xs: 'none', sm: 'block' },
                  position: 'relative' 
                }}
                onMouseEnter={() => setShowQR(true)}
                onMouseLeave={() => setShowQR(false)}
              >
                <IconButton
                  href="https://wa.me/6589208197"
                  target="_blank"
                  rel="noopener noreferrer"
                  size="small"
                  sx={{
                    color: '#25D366',
                    '&:hover': {
                      backgroundColor: 'rgba(37, 211, 102, 0.1)',
                      transform: 'scale(1.05)'
                    },
                    transition: 'all 0.2s ease'
                  }}
                >
                  <WhatsApp sx={{ fontSize: '1.3rem' }} />
                </IconButton>

                {/* 二维码悬停显示 */}
                {showQR && (
                  <Paper
                    elevation={8}
                    sx={{
                      position: 'absolute',
                      top: '100%',
                      right: 0,
                      mt: 1,
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: 'white',
                      border: '1px solid #e0e0e0',
                      zIndex: 1000,
                      minWidth: 180,
                      textAlign: 'center'
                    }}
                  >
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        color: '#2c3e50',
                        fontWeight: 600,
                        mb: 1,
                        fontSize: '0.8rem'
                      }}
                    >
                      Scan to WhatsApp
                    </Typography>
                    <Box
                      sx={{
                        width: 160,
                        height: 160,
                        backgroundColor: '#f5f5f5',
                        borderRadius: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: 'auto',
                        border: '2px dashed #ccc'
                      }}
                    >
                     <img src={qrCode} alt="WhatsApp QR Code" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                    </Box>
                    <Typography 
                      variant="caption" 
                      sx={{ 
                        color: '#666',
                        mt: 1,
                        display: 'block',
                        fontSize: '0.7rem'
                      }}
                    >
                      +65 89208197
                    </Typography>
                  </Paper>
                )}
              </Box>
            </Box>

            {/* 移动端联系信息 */}
            <Box sx={{ 
              display: { xs: 'flex', sm: 'none' }, 
              alignItems: 'center', 
              gap: 2 
            }}>
              {/* 电话 */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Phone sx={{ fontSize: '1.1rem', color: '#07284b' }} />
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: '#374151',
                    fontWeight: 600,
                    fontSize: '0.8rem'
                  }}
                >
                  +65 89208197
                </Typography>
              </Box>

              {/* 邮箱图标 */}
              <IconButton
                href="mailto:info@chihuimandarin.com"
                size="small"
                sx={{
                  color: '#07284b',
                  '&:hover': {
                    backgroundColor: 'rgba(7, 40, 75, 0.1)',
                    transform: 'scale(1.05)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                <Email sx={{ fontSize: '1.2rem' }} />
              </IconButton>

              {/* WhatsApp */}
              <IconButton
                href="https://wa.me/6589208197"
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                sx={{
                  color: '#25D366',
                  '&:hover': {
                    backgroundColor: 'rgba(37, 211, 102, 0.1)',
                    transform: 'scale(1.05)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                <WhatsApp sx={{ fontSize: '1.3rem' }} />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* 主导航栏 */}
      <AppBar 
        position="static" 
        sx={{ 
          backgroundColor: 'white', 
          color: 'primary.main',
          boxShadow: '0 2px 20px rgba(0,0,0,0.1)',
          backdropFilter: 'blur(10px)'
        }}
      >
        <Toolbar sx={{ maxWidth: 1400, mx: 'auto', width: '100%', px: { xs: 2, md: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <a href="/" style={{ textDecoration: 'none', fontSize: '0' }}>
            <Box
              component="img"
              src={logo}
              alt="CHIHUI Mandarin Logo"
              sx={{ width: 'auto', height: { xs: '78px', md: '100px' }, objectFit: 'cover', display: 'block' }}
            />
          </a>
        </Box>
        {/* 桌面导航 */}
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <Box 
            component="nav"
            sx={{ 
              display: 'flex', 
              gap: 3,
              alignItems: 'center',
              listStyle: 'none',
              margin: 0,
              padding: 0
            }}
          >
            <Box component="li">
              <Button 
                color="inherit" 
                href="/"
                size='large'
                sx={{ 
                  '&:hover': {
                    backgroundColor: 'rgba(37, 99, 235, 0.08)',
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                HOME
              </Button>
            </Box>
            <Box component="li">
              <Button 
                color="inherit" 
                href="/aboutus"
                size='large'
                sx={{ 
                  '&:hover': {
                    backgroundColor: 'rgba(37, 99, 235, 0.08)',
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                ABOUT
              </Button>
            </Box>
            <Box component="li" sx={{ position: 'relative' }}>
              <Button 
                id="courses-button"
                color="inherit" 
                size='large'
                href="/courses"
                onMouseEnter={handleCoursesMenuOpen}
                aria-controls={coursesMenuOpen ? 'courses-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={coursesMenuOpen ? 'true' : undefined}
                sx={{ 
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  '&:hover': {
                    backgroundColor: 'rgba(37, 99, 235, 0.08)',
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                COURSES
                <ArrowDropDown sx={{ fontSize: '1.5rem' }} />
              </Button>
              
              {/* COURSES 下拉菜单 */}
              <Menu
                id="courses-menu"
                anchorEl={coursesAnchorEl}
                open={coursesMenuOpen}
                onClose={handleCoursesMenuClose}
                MenuListProps={{
                  onMouseLeave: handleCoursesMenuClose,
                  'aria-labelledby': 'courses-button',
                }}
                disableAutoFocusItem
                disableRestoreFocus
                keepMounted={false}
                PaperProps={{
                  elevation: 8,
                  sx: {
                    mt: 1,
                    minWidth: 280,
                    borderRadius: 2,
                    border: '1px solid #e0e0e0',
                    '& .MuiMenuItem-root': {
                      px: 2,
                      py: 1.5,
                      '&:hover': {
                        backgroundColor: 'rgba(7, 40, 75, 0.08)'
                      }
                    }
                  }
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
              >
                {courses.map((course, index) => (
                  <MenuItem 
                    key={index}
                    onClick={handleCoursesMenuClose}
                    component="a"
                    href={course.href}
                    sx={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <ListItemIcon sx={{ color: '#07284b', minWidth: 40 }}>
                      {course.icon}
                    </ListItemIcon>
                    <ListItemText 
                      primary={course.name}
                      primaryTypographyProps={{
                        fontWeight: 500,
                        fontSize: '0.9rem'
                      }}
                    />
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            <Box component="li">
              <Button 
                color="inherit" 
                href="/knowledge"
                size='large'
                sx={{ 
                  '&:hover': {
                    backgroundColor: 'rgba(37, 99, 235, 0.08)',
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                KNOWLEDGE
              </Button>
            </Box>
            <Box component="li">
              <Button 
                color="inherit" 
                href="/contact"
                size='large'
                sx={{ 
                  '&:hover': {
                    backgroundColor: 'rgba(37, 99, 235, 0.08)',
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                CONTACT
              </Button>
            </Box>
          </Box>
        </Box>
        {/* 移动端菜单按钮 */}
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          <IconButton aria-label="open menu" onClick={toggleMobileDrawer(true)}>
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
    {/* 移动端抽屉导航 */}
    <Drawer anchor="right" open={mobileOpen} onClose={toggleMobileDrawer(false)}>
      <Box sx={{ width: 280 }} role="presentation">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1 }}>
          <a href="/" style={{ textDecoration: 'none', fontSize: '0' }}>
            <Box component="img" src={logo} alt="CHIHUI Mandarin Logo" sx={{ width: 'auto', height: '68px', objectFit: 'cover', display: 'block' }} />
          </a>
          <IconButton aria-label="close menu" onClick={toggleMobileDrawer(false)}>
            <Close />
          </IconButton>
        </Box>
        <Divider />
        <List>
          <ListItemButton component="a" href="/" onClick={toggleMobileDrawer(false)}>
            <ListItemText primary="HOME" />
          </ListItemButton>
          <ListItemButton component="a" href="/aboutus" onClick={toggleMobileDrawer(false)}>
            <ListItemText primary="ABOUT" />
          </ListItemButton>
          <ListItemButton onClick={handleToggleMobileCourses}>
            <ListItemText primary="COURSES" />
            {mobileCoursesOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={mobileCoursesOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {courses.map((course, index) => (
                <ListItemButton key={index} component="a" href={course.href} sx={{ pl: 4 }} onClick={toggleMobileDrawer(false)}>
                  <ListItemIcon sx={{ color: '#07284b', minWidth: 40 }}>
                    {course.icon}
                  </ListItemIcon>
                  <ListItemText primary={course.name} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
          <ListItemButton component="a" href="/knowledge" onClick={toggleMobileDrawer(false)}>
            <ListItemText primary="KNOWLEDGE" />
          </ListItemButton>
          <ListItemButton component="a" href="/contact" onClick={toggleMobileDrawer(false)}>
            <ListItemText primary="CONTACT" />
          </ListItemButton>
        </List>
        <Divider />
        {/* 移动端联系方式 */}
        <Box sx={{ p: 2, mt: 'auto' }}>
          <Typography variant="subtitle2" sx={{ color: '#07284b', fontWeight: 600, mb: 2 }}>
            Contact Us
          </Typography>
          {/* 电话 */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
            <Phone sx={{ fontSize: '1.1rem', color: '#07284b' }} />
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#374151',
                fontWeight: 500,
                fontSize: '0.9rem'
              }}
            >
              +65 89208197
            </Typography>
          </Box>
          {/* 邮箱 */}
          <Box 
            component="a"
            href="mailto:info@chihuimandarin.com"
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1, 
              mb: 1.5,
              textDecoration: 'none',
              cursor: 'pointer',
              transition: 'opacity 0.2s ease',
              '&:hover': {
                opacity: 0.8
              }
            }}
          >
            <Email sx={{ fontSize: '1.1rem', color: '#07284b' }} />
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#374151',
                fontWeight: 500,
                fontSize: '0.9rem'
              }}
            >
              info@chihuimandarin.com
            </Typography>
          </Box>
          {/* WhatsApp */}
          <Box 
            component="a"
            href="https://wa.me/6589208197"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              textDecoration: 'none',
              cursor: 'pointer',
              transition: 'opacity 0.2s ease',
              '&:hover': {
                opacity: 0.8
              }
            }}
          >
            <WhatsApp sx={{ fontSize: '1.3rem', color: '#25D366' }} />
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#374151',
                fontWeight: 500,
                fontSize: '0.9rem'
              }}
            >
              WhatsApp Chat
            </Typography>
          </Box>
        </Box>
      </Box>
    </Drawer>
    </Box>
  );
}

export default Header;
